var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "learn",
    transform: "translate(-535 -326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    transform: "translate(535 326)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "online-recruitment",
    transform: "translate(540 331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M13.075,21A2.018,2.018,0,0,0,11.1,22.612h3.948A2.018,2.018,0,0,0,13.075,21Z",
    transform: "translate(-4.837 -10.748)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M45.912,25.732l-.9-.674a3.266,3.266,0,0,0-.493.124l.408.944Z",
    transform: "translate(-24.792 -13.171)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M49.451,23.219l-.093-.279a1.936,1.936,0,0,1-.239.024H47.508a1.95,1.95,0,0,1-.239-.024l-.093.279,1.138.853Z",
    transform: "translate(-26.378 -11.906)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M53.415,25.182a3.266,3.266,0,0,0-.493-.124l-.9.674.985.394Z",
    transform: "translate(-29.272 -13.171)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 1.583,
    cy: 1.583,
    r: 1.583,
    transform: "translate(6.768 6.768)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M54.684,28.961a3.281,3.281,0,0,0-1.5-2.725l-.705,1.633-2.058-.823a1.2,1.2,0,0,1,.232.706v1.209Z",
    transform: "translate(-28.317 -13.874)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 1.583,
    cy: 1.583,
    r: 1.583,
    transform: "translate(6.768 14.684)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M13.075,41A2.018,2.018,0,0,0,11.1,42.612h3.948A2.018,2.018,0,0,0,13.075,41Z",
    transform: "translate(-4.837 -22.69)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M41.417,27.783l-.214.086L40.5,26.236A3.281,3.281,0,0,0,39,28.961h2.417Z",
    transform: "translate(-21.496 -13.874)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M41.149,7.739a1.6,1.6,0,0,1,.657-.143h.074a1.207,1.207,0,0,1,.616-.684L41.958,5.3A1.719,1.719,0,0,0,41,6.84v.091a1.718,1.718,0,0,0,.052.418Z",
    transform: "translate(-22.69 -1.373)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M44.435,55l-.3,2.417h5.533L49.364,55Z",
    transform: "translate(-24.561 -31.05)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M47.461,33.029a.4.4,0,0,0-.4.4v2.014h-.806v-2.82a.4.4,0,1,0-.806,0v2.82H44.64V31.82a.4.4,0,0,0-.806,0v3.626h-.806V29.4a.4.4,0,1,0-.806,0v4.986a1.057,1.057,0,0,1-2.1.174l-.169-1.015a.619.619,0,0,0-.613-.519A.342.342,0,0,0,39,33.37a.376.376,0,0,0,0,.056l.5,3a3.147,3.147,0,0,0,1.609,2.246h5.4a3.645,3.645,0,0,0,1.347-2.82V33.432A.4.4,0,0,0,47.461,33.029Z",
    transform: "translate(-21.496 -15.525)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M17.681,23.533H4.612a.807.807,0,0,1-.806-.806V6.612a.807.807,0,0,1,.806-.806H17.656A2.516,2.516,0,0,1,18.135,5H4.612A1.613,1.613,0,0,0,3,6.612V25.95a1.613,1.613,0,0,0,1.612,1.612H18.76l.326-2.606A3.951,3.951,0,0,1,17.681,23.533Zm-3.8,2.417a.4.4,0,0,1-.4.4H10.252a.4.4,0,0,1-.4-.4v-.806a.4.4,0,0,1,.4-.4h3.223a.4.4,0,0,1,.4.4Z",
    transform: "translate(0 -1.194)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M48.719,5.417a1.207,1.207,0,0,1,1.135.806h.074a1.6,1.6,0,0,1,.657.143l.075-.3A2.467,2.467,0,0,0,48.267,3H46.636a2.331,2.331,0,0,0-1.48.525l.631,1.892Z",
    transform: "translate(-25.172 0)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M41.806,14.612V13a.806.806,0,0,0,0,1.612Z",
    transform: "translate(-22.69 -5.971)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M57.806,13.806A.807.807,0,0,0,57,13v1.612A.807.807,0,0,0,57.806,13.806Z",
    transform: "translate(-32.244 -5.971)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M46.209,15.029H47.82a1.21,1.21,0,0,0,1.209-1.209V11.4a.4.4,0,0,0-.4-.4H45.4a.4.4,0,0,0-.4.4V13.82A1.21,1.21,0,0,0,46.209,15.029Zm-.4-1.612h1.209a.9.9,0,0,0,.806-.5l.042-.085.721.361-.042.085a1.7,1.7,0,0,1-1.527.943H45.806Z",
    transform: "translate(-25.079 -4.777)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    transform: "translate(552 339)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    transform: "translate(552 341)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    transform: "translate(555 339)",
    fill: "#fff",
    stroke: "#3e3e3e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.0985669b19bebef5a7ca4e520ac10e5c.svg";
export { ForwardRef as ReactComponent };